import * as React from "react";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import * as _ from "lodash";
import {
    CalendarState,
    OwnerPage,
    OwnerPageInfo,
    OwnerPageResponse,
} from "burde";
import { OwnerPageSelectorDisplay } from "./owner-page-selector-display";
import * as styles from "./owner-page.css";
import {
    actionCreators as calendarActionCreators,
    getCalendar,
    getOwnerPage,
} from "page/calendar/store";
import { actionCreators as uiActionCreators } from "ui/store";
import { ApplicationState } from "store";
import { getOwnerPageOptions } from "burde-api-content/store";

type Props = {
    updateOwnerPageLayoutId: (id: number) => any;
    calendar: CalendarState;
    ownerPage: OwnerPageInfo;
    ownerPageOptions: OwnerPageResponse | null;
} & typeof calendarActionCreators &
    typeof uiActionCreators;

export const OwnerPageSelector = ({
    updateOwnerPageLayoutId,
    calendar,
    ownerPageOptions,
}: Props) => {
    const [selectedResourceGroup, setSelectedResourceGroup] = useState("");

    useEffect(() => {
        initialize();
    }, [ownerPageOptions]);

    const initialize = async () => {
        if (ownerPageOptions) {
            // Find selected tab
            for (
                let i = 0;
                i < ownerPageOptions.ownerPageResources.length;
                i++
            ) {
                let found = ownerPageOptions.ownerPageResources[
                    i
                ].ownerPages.find(
                    (ownerPage: OwnerPage) =>
                        ownerPage.id == calendar.ownerPage.layoutId,
                );

                if (found !== undefined) {
                    // Update default layout
                    setSelectedResourceGroup(
                        ownerPageOptions.ownerPageResources[i]
                            .resourceGroupTitle,
                    );
                    break;
                } else if (ownerPageOptions.ownerPageResources.length > 0) {
                    // Set default group
                    setSelectedResourceGroup(
                        ownerPageOptions.ownerPageResources[0]
                            .resourceGroupTitle,
                    );
                }
            }
        }
    };

    const onSelect = (page: OwnerPage) => {
        updateOwnerPageLayoutId(page.id);
    };

    return (
        <>
            <ul className={styles.tabGroup}>
                {ownerPageOptions &&
                    ownerPageOptions.ownerPageResources.length > 1 &&
                    ownerPageOptions.ownerPageResources.map((r) => (
                        <li
                            key={r.resourceGroupTitle}
                            className={styles.tabGroupLi}>
                            <a
                                className={`${styles.categoryTabItem} ${
                                    r.resourceGroupTitle ===
                                    selectedResourceGroup
                                        ? styles.categoryTabItemSelected
                                        : ""
                                }`}
                                onClick={() => {
                                    setSelectedResourceGroup(
                                        r.resourceGroupTitle,
                                    );
                                }}>
                                {r.resourceGroupTitle}
                            </a>
                        </li>
                    ))}
            </ul>

            {selectedResourceGroup &&
                ownerPageOptions &&
                ownerPageOptions.ownerPageResources && (
                    <OwnerPageSelectorDisplay
                        ownerPageResources={ownerPageOptions.ownerPageResources}
                        selectedResourceGroup={selectedResourceGroup}
                        selectedOwnerPageId={calendar.ownerPage.layoutId}
                        onSelect={onSelect}
                    />
                )}
        </>
    );
};

const mapStateToProps = (state: ApplicationState) => ({
    calendar: getCalendar(state),
    ownerPage: getOwnerPage(state),
    ownerPageOptions: getOwnerPageOptions(state),
});

const mapDispatchToProps = {
    ...uiActionCreators,
    ...calendarActionCreators,
};

const ConnectedOwnerPageSelector = connect(
    mapStateToProps,
    mapDispatchToProps,
)(OwnerPageSelector);

export { ConnectedOwnerPageSelector };
